/**
 * How an episode status is worded for a clinician.
 *
 * The stored value is not the shown one: an episode closed early is
 * `cancelled` in the database but reads as "Inactive" on screen, because
 * nothing about the episode was cancelled in the billing sense. Shared so the
 * episode editor and the patient summary cannot drift into calling the same
 * episode two different things.
 */
export function statusDisplayLabel(status: string): string {
  if (status === 'cancelled') return 'Inactive';
  if (status === 'active') return 'Active';
  return status;
}
